import { PlaceholderPage } from '../components/PlaceholderPage';

export const Terms = () => {
  return (
    <PlaceholderPage
      title="Terms of Service"
      description="The terms and conditions that govern your use of WineryXplorer."
    />
  );
};
